<!-- 我的订单详情 -->
<template>
    <cc-container>
      <skeleton v-if="showSkeleton" />
     <template v-else>
     <cc-header-nav title="订单详情" :url="comeOrder?'/#/orderer?id=0':''" >
        <template slot="right">
        <div  class="ellipsis">
          <van-icon class="ellipsis-icon" name="ellipsis" @click.stop="isShowSmallNav = !isShowSmallNav" />
        </div>
        </template>
      </cc-header-nav>
      <cc-main v-if="orderData" ref="main">
       <cc-pull-refresh v-model="isLoading" @refresh="onRefresh" class="pull-refresh" >
        <div class="status-bar" >
          <template v-if="+orderData.payment_method==1&&+orderData.payment_state==0&&+orderData.order_state!==3">
            <div class="status-left" v-if="orderData.order_state==0 ||orderData.order_state==10">
                <div class="status">
                 <cc-svg-icon
                  icon-class="timeclock"
                  class-name="timeclock"
                  size=".24rem"
                ></cc-svg-icon>
                    {{orderData.order_state_name}}
                 </div>
                <div class="pay-money">
                    <p v-if="+delivery==1">需付款：<span style="font-size:15px;color:red">配送价</span></p>
                    <p v-else>需付款：￥<span>{{orderData.paid|numFilter(2)}}</span></p>
                  </div>
                  <div class="time">
                    <p v-if="orderData.order_state==10">确认剩余时间</p>
                    <p v-if="orderData.order_state==0">支付剩余时间</p>
                    <div class="right" v-if="orderData.countDown">
                          <p><span class="gray">{{orderData.countDown.h}}</span></p>：
                          <p><span class="gray">{{orderData.countDown.m}}</span></p>：
                          <p><span class="gray">{{orderData.countDown.s}}</span></p>
                    </div>
                </div>
            </div>
          </template>
          <div class="status-left" v-else>
                <div class="status status-center status-center-one">
                 <cc-svg-icon
                  v-if="+orderData.order_state==1||+orderData.order_state==0"
                  icon-class="timeclock"
                  class-name="timeclock"
                  size=".24rem"
                ></cc-svg-icon>
                 <cc-svg-icon
                  v-if="+orderData.order_state==3"
                  icon-class="errorcode"
                  class-name="errorcode"
                  size=".24rem"
                ></cc-svg-icon>
                <cc-svg-icon
                 v-if="+orderData.order_state==4"
                  icon-class="sucesscode"
                  class-name="sucesscode"
                  size=".24rem"
                ></cc-svg-icon>
              {{orderData.order_state_name}}
                </div>
              </div>
              <div class="status-right">
                   <span></span>
              </div>
          </div>
        <div class="item-block" style="margin-top:-10px">
          <div class="information">
            <div class="wrap-address-icon">
              <img :src="require('@/assets/img/address.png')" alt="">
            </div>
            <div class="customer-info">
              <p class="site">{{orderData.customer_name}}</p>
              <p class="name">{{orderData.contacter}} {{orderData.contacter_mobile}}</p>
              <p class="place">{{orderData.address}}</p>
            </div>
          </div>
        </div>
        <div class="item-block" style="padding:10px 0" >
          <div class="goods-line">
            <p class="product-ist">商品列表</p>
            <p class="product-num">{{orderData.goods_num}}种商品</p>
          </div>
          <div class="goods-list-box">
          <div ref="industryRef" :class="{'hidde':goodshow,'hidde-height':hiddeHeight}">
          <div v-for="(orderValue,index) in orderData.order_goods" :key="index+1" >
            <div class="promotion-instructions" v-if="!Array.isArray(orderValue.promotion_info)" ref="promotion">【全场促销】{{orderValue.promotion_info.title}} ({{orderValue.promotion_info.promotion_content}})</div>
          <div class="goods-list"   v-for="(itemValue,itemKey,m) in orderValue.goods_list" :key="m">
            <!-- 单个商品 开始-->
            <template v-if="+itemKey!==3">
            <div class="one-item" v-for="(goodsValue,j) in itemValue" :key="j">
            <div class="goods-list-item" >
              <div class="goods-pic">
                <img :src="goodsValue.image||$notImg"/>
                 <cc-svg-icon
                  v-if="+goodsValue.state!=1"
                  icon-class="Invalidcode"
                  class-name="Invalidcode"
                  size=".36rem"
                ></cc-svg-icon>
              </div>
              <div class="goods-msg">
                <div class="info">
                 <p class="title-txt">{{goodsValue.general_name}} {{goodsValue.norms}}</p>
                </div>
                <p class="manufacturer">{{goodsValue.produce_unit}} </p>
                <div class="batch">
                <p class="batch-number">批号：{{goodsValue.batch_code}}</p>
                 <span>x{{goodsValue.quantity}}</span>
                </div>
                <div class="price">
                  <div class="price-detail" v-if="delivery!=1">
                    <template v-if="+goodsValue.type!=6">
                    <p class="price-org"><span>￥</span>{{goodsValue.bid_price|numFilter(4)}}</p>
                    <span class="actual-payment">实付￥{{goodsValue.actually_price|numFilter(4)}}</span>
                    </template>
                    <template v-else>
                      <span style="font-size:15px;color:red">{{goodsValue.actually_price}}积分</span>
                    </template>
                    </div>
                    <div class="price-detail" v-else>
                    <span style="font-size:15px;color:red">配送价</span>
                    </div>
                </div>
                <div class="activity-tag" v-if="+goodsValue.type!==1">
                  <p class="activity"><span class="tag">{{goodsType[goodsValue.type]}}</span></p>
                </div>
              </div>
              </div>
            </div>
            </template>
            <!-- 单个商品结束 -->
            <!-- 套装开始 -->
              <div class="one-item" v-for="(goods,setKey,k) in itemValue" :key="goods.goods_id" v-else>
            <div class="suit-border suit-border-line" :class="{'suit-border-line-none':k==0&&hideSuitLine}" v-if="+itemKey==3">
              <div class="goods-list-item"  v-for="(item,b) in goods" :key="b">
              <div class="goods-pic">
                <img :src="item.image||$notImg"/>
                 <cc-svg-icon
                 v-if="+item.state!=1"
                  icon-class="Invalidcode"
                  class-name="Invalidcode"
                  size=".35rem"
                ></cc-svg-icon>
              </div>
              <div class="goods-msg">
                <div class="info">
                 {{item.general_name}} {{item.norms}}
                </div>
                <p class="manufacturer">{{item.produce_unit}}</p>
                <div class="batch">
                <p class="batch-number">批号：{{item.batch_code}}</p>
                 <span>x{{item.quantity}}</span>
                </div>
                <div class="price" >
                    <div class="price-detail" v-if="+delivery!=1">
                    <p class="price-org"><span>￥</span>{{item.price|numFilter(4)}}</p>
                    <!-- <span class="actual-payment">实付￥{{item.retail_price|numFilter(4)}}</span> -->
                    </div>
                    <!-- 积分兑换 、配送价-->
                    <div class="price-detail" v-else>
                    <span style="font-size:15px;color:red">配送价</span>
                    </div>
                </div>
              </div>
              </div>
               <div class="suit">
               <div class="suit-left">
                <p class="suit-tag">套装</p>
                <p class="suit-money"><span>￥</span>{{goods[k].bid_price|numFilter(4)}}</p>
                <p class="suit-payment">实付￥{{goods[k].bid_price|numFilter(4)}}</p>
               </div>
               <div class="suit-right">x{{goods[k].quantity}}</div>
            </div>
               </div>
            <!-- 套装结束 -->
          </div>
          </div>
          </div>
          </div>
          <div class="view-more" @click="changeAuto" v-show="showmore">{{handleTxt}} <span>
            <cc-svg-icon
                  :icon-class="handleIcon"
                  :class-name="handleIcon"
                  size=".13rem"
            ></cc-svg-icon></span></div>
          <div class="line-center"></div>
          <div class="preferential">
             <p v-if="+delivery==1"><span>商品总额：</span><span style="font-size:15px;color:red">配送价</span></p>
             <p v-else><span>商品总额：</span><span class="num"><em class="xsmall">￥</em>{{orderData.priced|numFilter(2)}}</span></p>
             <p v-if="+orderData.coupon_price"><span>优惠券：</span><span class="num1">-￥{{orderData.coupon_price|numFilter(2)}}</span></p>
             <p v-if="+orderData.discount_coupon_price"><span>全场促销：</span><span class="num1">-￥{{orderData.discount_coupon_price|numFilter(2)}}</span></p>
             <p v-if="+orderData.use_coupon_price"><span>积分抵现：</span><span class="num1">-￥{{orderData.use_coupon_price|numFilter(2)}}</span></p>
             <p><span>运费：</span><span class="num1">￥{{orderData.express_price|numFilter(2)}}</span></p>
             <p>
               <template v-if="+orderData.payment_method==1&&+orderData.payment_state==0&&+orderData.order_state!==3">
               <span v-if="orderData.order_state==0 ||orderData.order_state==10">应付总额：</span>
               </template>
               <span v-else>实付款：</span>
               <span class="num2" v-if="+delivery!=1"><em class="xsmall">￥</em>{{orderData.paid|numFilter(2)}}</span>
               <span v-else style="font-size:15px;color:red">配送价</span>
               </p>
          </div>
          </div>
        </div>
        <!-- 发票开始 -->
        <div class="item-block invoice" @click="isInvoicePopup = true" v-if="orderData.order_invoice.invoice_type>0">
          <van-cell title="发票信息" is-link />
        </div>
         <div class="item-block invoice" v-else >
          <van-cell title="发票信息"  value="无" />
        </div>
        <!-- 发票结束 -->
        <div class="item-block">
       <div class="order-msg-content" :class="{'order-msg-content-auto':orderMsgAuto}">
           <div class="order-msg">
           <span>订单号：</span>
           <p class="order-nmb">{{orderData.order_number}}</p>
           <p class="copy"
           v-if="orderData.order_number"
            v-clipboard:copy ="orderData.order_number"
            v-clipboard:success ="onCopy"
            v-clipboard:error ="onError"
           >复制</p>
            <!-- <p class="copy"
           >复制</p> -->
           </div>
            <div class="order-msg" v-if="+orderData.from_replace_member_id">
              <span>代下单：</span>
              <p>{{orderData.distributor_contacter}}</p>
            </div>
            <div class="order-msg">
              <span>下单时间：</span>
              <p>{{orderData.post_date}} </p>
            </div>
            <div class="order-msg">
              <span>支付时间：</span>
              <p>{{orderData.order_payment_date}}</p>
            </div>
            <div class="order-msg order-msg-style">
              <span>运单号：</span>
            <div class="waybill"  v-if="orderData.waybill_number!=undefined && orderData.waybill_number.length>0">
              <div class="waybill-item" v-for="(val,h) in orderData.waybill_number" :key="h">
                <p class="order-nmb">{{val}}</p>
                <p class="copy"
                  v-clipboard:copy ="val"
                  v-clipboard:success ="onCopy"
                  v-clipboard:error ="onError"
                >复制</p>
              </div>
            </div>
          </div>
        <div class="order-msg order-msg-style">
           <span>留言：</span>
           <p class="msg_tip">{{orderData.message}}</p>
         </div>
         <div class="line"></div>
         <div class="order-msg">
           <span>结款方式：</span>
           <p>{{orderData.payment_method_name}}</p>
         </div>
         <div class="order-msg">
           <span>验货须知：</span>
           <p>现场数量点清</p>
         </div>
         <div class="order-msg">
           <span>退货须知：</span>
           <p>非质量问题不予退货</p>
         </div>
       </div>
         <div class="full-information" :class="{'fullView-hidden':viewhidden}" @click="fullView">查看完整信息 <span> <cc-svg-icon
                  icon-class="downcode"
                  class-name="downcode"
                  size=".1rem"
                ></cc-svg-icon></span></div>
         </div>
          </cc-pull-refresh>
      </cc-main>
      <cc-footer>
        <div class="manipulate">
           <blockquote v-if="+orderData.payment_method==1&&+orderData.payment_state==0">
          <p @click="orderCancel(orderData.order_number)" v-if="+orderData.order_state==0||+orderData.order_state==10">取消订单</p>
          </blockquote>
          <p class="identification" @click="orderConfirm(orderData.order_number)"  v-if="+orderData.order_state==10&&this.getLoginStatus.data.replace_member_id==0">确认订单</p>
          <blockquote v-if="+orderData.payment_method==1&&+orderData.payment_state==0">
          <p class="payment" v-if="(this.getLoginStatus.data.replace_member_id>0&&+orderData.order_state==0)||(this.getLoginStatus.data.replace_member_id==0&&(orderData.order_state==0||orderData.order_state==10))"
          @click="payMoney(orderData.order_number)"
            >立即支付</p>
           </blockquote>
          <p class="pay-refund" @click="refundPay(orderData.order_id)" v-if="+orderData.can_refund">申请退款</p>
          <p class="identification" v-if="+orderData.order_state===3 || !(orderData.payment_method==1 && orderData.payment_state==0)" @click="buyAgain(orderData.order_number)">再次购买</p>
          <p class="payment" v-if="+orderData.order_state==1 && orderData.order_state_name=='已发货'"  @click="orderok(orderData.order_number)">确认收货</p>
        </div>
      </cc-footer>
       <!-- 发票弹窗 -->
    <cc-bottom-popup
      title="发票"
      :height="556"
      @close="isInvoicePopup = false"
      :isShowPopup="isInvoicePopup"
      :showBtn="false"
    >
      <div class="invoice-popup">
       <div class="invoice-item">
         <p>发票类型：</p>
         <span>{{invoiceType[invoice.invoice_type]}}</span>
       </div>
          <div class="invoice-item">
         <p>公司名称：</p>
         <span>{{invoice.invoice_company_name}}</span>
       </div>
          <div class="invoice-item">
         <p>纳税人识别号：</p>
         <span>{{invoice.invoice_taxpayer_number}}</span>
       </div>
          <div class="invoice-item">
         <p>注册地址：</p>
         <span>{{invoice.invoice_taxpayer_regisaddress}}</span>
       </div>
          <div class="invoice-item">
         <p>注册电话：</p>
         <span>{{invoice.invoice_tel}}</span>
       </div>
          <div class="invoice-item">
         <p>开户银行：</p>
         <span>{{invoice.invoice_deposit_bank}}</span>
       </div>
         <div class="invoice-item">
         <p>银行账号：</p>
         <span>{{invoice.invoice_bank_account}}</span>
       </div>
      </div>
    </cc-bottom-popup>
     <cc-small-nav v-model="isShowSmallNav"/>
     </template>
    </cc-container>
</template>

<script>

import Vue from 'vue'
import { Dialog, Toast, List, Cell, Stepper, Icon, Lazyload } from 'vant'
import VueClipboard from 'vue-clipboard2'
import ListMixin from '@/mixins/list'
import { loadOrderDetail, againBuy, orderCancel, orderOk, orderConfirm } from '~fetch/manage-center/order-management'
import { ResultCode } from '~const/ResultCode'
import CountDownMixin from './../../../../mixins/countDown'
import { SessionStorage } from '@/utils'
import Command from '@/mixins/command'
import Skeleton from './skeleton.vue'
Vue.use(Dialog)
  .use(VueClipboard)
  .use(Toast)
  .use(List)
  .use(Cell)
  .use(Stepper)
  .use(Icon)
  .use(Lazyload)
export default {
  mixins: [ ListMixin, CountDownMixin, Command ],
  components: {
    Skeleton
  },
  data () {
    return {
      comeOrder: false,
      isLoading: false,
      delivery: '0',
      showSkeleton: true,
      goodshow: false,
      hiddeHeight: false,
      keepHeightType: '',
      showmore: false,
      orderMsgAuto: false,
      viewhidden: false,
      isShowSmallNav: false,
      hideSuitLine: false, // 控制套餐的border-top
      isInvoicePopup: false, // 发票弹窗
      orderData: {},
      handleTxt: '查看更多',
      handleIcon: 'downcode',
      bussinessHeight: '',
      invoice: {},
      time: {},
      goodsType: {
        '1': '普通',
        '2': '特价',
        '3': '套餐',
        '4': '满赠',
        '5': '赠品',
        '6': '兑换',
        '7': '抵现'
      },
      invoiceType: {
        '1': '普通发票',
        '2': '增值税专用发票'
      }
    }
  },

  computed: {

  },

  created () {
    this.loadData()
  },
  mounted () {
  },
  methods: {
    /**
     *  下拉刷新
     */
    onRefresh () {
      this.goodshow = false
      this.hiddeHeight = false
      this.handleTxt = '查看更多'
      this.handleIcon = 'downcode'
      this.orderMsgAuto = false
      this.viewhidden = false
      this.loadData()
    },
    // 获取数据
    judgeTime (item) {
      return parseInt(+item.end_time - +item.now_time)
    },
    async loadData () {
      if (this.$route.query.comeSuccess) {
        this.comeOrder = true
      }
      const orderNumber = this.$route.query.id
      let { status, data } = await loadOrderDetail({ order_number: orderNumber })
      if (status === ResultCode.SUCCESS) {
        this.isLoading = false
        this.showSkeleton = false
        this.orderData = data.data
        this.orderData.end_time = this.orderData.over_time
        this.invoice = this.orderData.order_invoice
        this.$set(this.orderData, 'countDown', {
          d: '',
          h: '',
          m: '',
          s: ''
        })
        this.countDown(this.orderData)
        if (this.getLoadSettingStatus && this.getLoadSettingStatus.data.is_delivery_flag) {
          this.delivery = this.getLoadSettingStatus.data.is_delivery_flag
        }
        if (+(this.orderData.order_goods[0] && Object.keys(this.orderData.order_goods[0].goods_list)[0]) === 3) {
          this.hideSuitLine = true
        }
        if (this.orderData.order_state_name === '已取消' || this.orderData.order_state_name === '待确认' || this.orderData.order_state_name === '待支付') {
          this.orderData.payment_method_name = ''
        }
      }
    },
    // 商品多余三个隐藏，点击查看更多进行切换
    changeAuto () {
      if (this.keepHeightType) {
        if (!this.hiddeHeight) {
          this.hiddeHeight = true
          this.handleTxt = '查看更多'
          this.handleIcon = 'downcode'
        } else {
          this.hiddeHeight = false
          this.handleTxt = '收起'
          this.handleIcon = 'upcode'
        }
      } else {
        if (!this.goodshow) {
          this.goodshow = true
          this.handleTxt = '查看更多'
          this.handleIcon = 'downcode'
        } else {
          this.goodshow = false
          this.handleTxt = '收起'
          this.handleIcon = 'upcode'
        }
      }
    },
    // 点击查看完整信息
    fullView () {
      this.orderMsgAuto = true
      this.viewhidden = true
    },
    refundPay (shopid) {
      this.$router.push({ path: '/apply/refund', query: { id: shopid } })
    },
    /**
     * @description 确认订单
     */
    orderConfirm (orderId) {
      Dialog.alert({
        message: '是否确认订单？',
        showCancelButton: true
      }).then(async () => {
        let res = await orderConfirm({
          type: 1,
          order_number: orderId
        })
        this.loadData()
        if (res.status === 0) {
          sessionStorage.setItem('comeOrderDetail', 1)
          this.loadData()
        } else {
          Toast(res.info.msg)
        }
      }).catch(() => {
        Dialog.close()
        // on cancel
      })
    },
    /**
     * @description 确认收货
     */
    orderok (orderId) {
      Dialog.alert({
        message: '是否确认收货？',
        showCancelButton: true
      }).then(async () => {
        let res = await orderOk({
          order_number: orderId
        })
        if (res.status === 0) {
          sessionStorage.setItem('comeOrderDetail', 1)
          this.loadData()
        } else {
          Toast(res.info.msg)
        }
      }).catch(() => {
        Dialog.close()
        // on cancel
      })
    },
    /**
     * @description 取消订单
     */
    orderCancel (orderid) {
      Dialog.alert({
        message: '是否取消订单',
        confirmButtonText: '确定取消',
        cancelButtonText: '暂不取消',
        showCancelButton: true
      }).then(async () => {
        let res = await orderCancel({
          order_number: orderid
        })
        if (res.status === 0) {
          sessionStorage.setItem('comeOrderDetail', 1)
          this.loadData()
        } else {
          Toast(res.info.msg)
        }
      }).catch(() => {
        Dialog.close()
        // on cancel
      })
    },
    /**
     * 再次购买
     */
    async buyAgain (orderId) {
      let res = await againBuy({
        order_number: orderId
      })
      if (res.status === 0) {
        Toast(res.info.msg)
        this.cartGetnum()
        SessionStorage.setItem('hasNewGoods', '1')
      } else {
        Toast(res.info.msg)
      }
    },
    /**
     * @description 立即支付
     */
    payMoney (id) {
      window.location = '/order/success/?order_number=' + id
    },
    // 复制订单号
    onCopy: function (e) {
      Toast({
        message: '复制成功',
        duration: 2000
      })
    },
    onError: function (e) {
      console.log(e)
      Toast({
        message: '复制失败',
        duration: 2000
      })
    }
  },
  filters: {
    numFilter (value, num) {
      // 截取当前数据到小数点后几位
      let realVal = parseFloat(value).toFixed(num)
      return realVal
    }
  },
  watch: {
    orderData () {
      this.$nextTick(() => {
        if (this.$refs['industryRef']) {
          let cur = this.$refs['industryRef'].clientHeight
          if (this.$refs['promotion'] && this.$refs['promotion'][0].clientHeight > 0) {
            this.keepHeightType = 1
            if (cur > 361) {
              this.showmore = true
              this.hiddeHeight = true
            } else {
              this.showmore = false
            }
          } else {
            this.keepHeightType = 0
            if (cur > 345) {
              this.showmore = true
              this.goodshow = true
            } else {
              this.showmore = false
            }
          }
        }
      })
    }
  }
}

</script>
<style lang='scss' scoped>
/deep/.van-stepper__minus{
  display: none;
}
/deep/.van-stepper__plus{
 display: none;
}

.status-bar{
  height: 110px;
  width: 100%;
  display: flex;
  flex-direction: row;
  padding-top: 10px;
  background: linear-gradient(to right, var(--APP_theme_color), var(--APP_theme_color_colorOpacity5));
  .status-left{
      width: 60%;
       color: #fff;
       padding: 0 0 0 30px;
       box-sizing: border-box;
       position: relative;
       .status{
        font-size: 18px;
        letter-spacing:1px;
        font-weight: 700;
        }
        .status-center{
          position: absolute;
          top: 40%;
          left: 50%;
          transform: translate(-50%,-50%);
        }
        .status-center-one{
          left: 40%;
        }
       .pay-money{
         margin: 10px 0;
        p{
           >span{
           font-size: 18px;
         }
        }
       }
     }
  .status-right{
      width: 40%;
      >span{
          background: url("./../../../../assets/img/management/detailmoney.png") no-repeat;
          margin-bottom: 16px;
          background-size:100%;
          display: inline-block;
          width: 122px;
          height: 91px;
      }
    }

}
.time{
  color: #fff;
  font-size: 10px;
  display: flex;
  flex-direction: row;
}
.right{
  margin-left: 5px;
  display: flex;
  flex-direction: row;
  p{
  width: 15px;
   height: 15px;
   line-height: 15px;
   background: #fff;
   border-radius: 2px;
   text-align: center;
   display: flex;
   flex-direction: row;
   align-items: center;
   justify-content: center;
     .gray{
   font-size: 10px;
  //  transform:scale(0.8);
   color: var(--APP_theme_color);
   margin-top: 2px;

  }
  }

}
.item-block{
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 10px;
  margin-bottom: 10px;
  .line{
    width: 285px;
    height: 0.5px;
    background: #EEEEEEFF;
    margin: 10px 0 10px 100px;
  }
}
.information{
  display: flex;
  flex-direction: row;
  .wrap-address-icon{
    width: 14px;
    height: 18px;
    margin-right: 10px;
    img{
      width: 100%;
    }
  }
  .customer-info{
    .site{
      font-size: 14px;
      color: #333333FF;
    }
    .name{
      font-size: 13px;
      color: #555555FF;
      margin: 10px 0;
    }
    .place{
      font-size: 12px;
      color: #777777FF;
    }
  }
}
.goods-line{
  display: flex;
  flex-direction: row;
  justify-content:space-between;
  border-bottom: 1px solid #F9F9F9FF;
  padding: 0 10px 10px;
  .product-ist{
    font-size: 14px;
    color: #333333FF;
    font-weight: 700;
  }
  .product-num{
    font-size: 12px;
    color: #999999FF;
  }
}
.goods-list-box{
  padding: 10px 10px 0;
}
.promotion-instructions{
  margin-bottom: 10px;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}

.goods-list{
  height: auto;
  // overflow: hidden;
  // padding-bottom: 5px;
 &-item{
   display: flex;
   flex-direction: row;
   align-items: center;
    margin-bottom: 15px;
    height: 100px;
    .one-item{
      width: 100%;
   display: flex;
   flex-direction: row;
   align-items: center;
    }
   .goods-pic{
     width: 56px;
     height: 56px;
     margin-right: 10px;
     position: relative;
     img{
      width: 100%;
      height: 100%;
      border-radius: 4px;
     }
     .Invalidcode{
       position: absolute;
       right: 0;
       bottom: 0;
     }
   }
   .goods-msg{
     width: 288px;
     .info{
       font-size: 14px;
       color:#343434FF;
       display: flex;
       flex-direction: row;
       align-items: center;
      overflow: hidden;
       text-overflow:ellipsis;
       white-space: nowrap;
       .title-txt{
        overflow: hidden;
       text-overflow:ellipsis;
       white-space: nowrap;
       }
       .info_tag{
       width: 30px;
       height: 15px;
       background-color: #F73446FF;
       border-radius: 2px;
       display: flex;
       align-items: center;
       justify-content: center;
       font-size: 12px;
       color: #fff;
       margin-right: 5px;
       }
     }
     .manufacturer{
       color: #999999FF;
       font-size: 12px;
     }
     .batch{
       display: flex;
       flex-direction: row;
       justify-content:space-between;
       align-items: center;
       margin-bottom: 10px;
     }
     .batch-number{
       font-size: 12px;
       color: #9A9A9AFF;
     }
     .price{
       font-size: 13px;
       color: #787878FF;
       display: flex;
       flex-direction: row;
       align-items: center;
       justify-content:space-between;
       .price-detail{
         display: flex;
         flex-direction: row;
         justify-content: center;
         align-items: center;
         .price-org{
           font-size: 18px;
           color: #E61A20FF;
           span{
             font-size: 12px;
           }
         }
         del{
           font-size: 12px;
           margin: 0 8px;
           color: #777;
         }
         .actual-payment{
           color: #777;
           font-size: 12px;
           margin-left: 10px;
         }
       }
     }
     .activity-tag{
       margin-top: 5px;
      .activity{
       width: 24px;
       height: 13px;
       border: 1px solid #F24571FF;
       border-radius: 2px;
       background-color: #FB526EFF;
       color: #fff;
       display: flex;
       flex-direction: row;
       align-items: center;
       justify-content: center;
      .tag{
       font-size: 10px;
     }
     }

     }

   }
 }
 .suit-border{
   padding-top: 10px;
 }
 .suit-border-line{
   margin-top: 10px;
  border-top: 1px solid #f3f3f3;
 }
 .suit-border-line-none{
   margin-top: 0;
   border-top: none;
 }
 .suit{
   display: flex;
   flex-direction: row;
   align-items: center;
   justify-content:space-between;
   margin-bottom: 15px;
   .suit-left{
     display: flex;
     flex-direction: row;
     align-items: center;
     .suit-tag{
       width: 30px;
       height: 15px;
       background-color: #F73446FF;
       border-radius: 2px;
       display: flex;
       align-items: center;
       justify-content: center;
       font-size: 12px;
       color: #fff;
     }
     .suit-money{
       font-size: 18px;
       color: #EA2828FF;
       margin: 0 10px;
       display: flex;
       flex-direction: row;
       justify-content: center;
       align-items: center;
       span{
         font-size: 12px;
       }
     }
     .suit-payment{
       font-size: 12px;
       color: #777;
     }
   }
   .suit-right{
     font-size: 14px;
     color: #343434FF;
   }
 }
}
.hidde{
      height: 345px;
      overflow: hidden;
    }
.hidde-height{
  height: 361px;
   overflow: hidden;
}
.goods-list-auto{
  height: auto;
}
.handleIcon{
  color: #999999FF;
}
.view-more{
  text-align: center;
  color: #999999FF;
  margin: 8px 0 15px;
}
.line-center{
  width: 355px;
  height: 2px;
  background-color: #F9F9F9FF;
  margin: 10px auto;
}
.preferential{
  p{
    display: flex;
    justify-content:space-between;
    margin-top: 10px;
    font-size: 12px;
    color: #999999FF;
    .num{
      font-size: 15px;
      color: #333333FF;
    }
    .num1{
      font-size: 12px;
      color: #333333FF;
    }
    .num2{
      font-size: 15px;
      color: #F53737FF;
    }
    .xsmall{
      font-size: 12px;
    }
  }
}
.invoice{
  display: flex;
  justify-content:space-between;
  height: 45px;
  line-height: 45px;
  padding: 0 10px;
  font-size: 12px;
  color: #555555FF;
  .arrow{
    font-size: 20px;
    color: #777777FF;
  }
  /deep/.van-cell {
    color: #555555FF;
    padding: 10px 0;
  }
}
.order-msg-content{
  height: 28px;
  overflow: hidden;
}
.order-msg-content-auto{
  height: auto;
}
.order-msg{
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 12px;
  color: #999999FF;
  margin: 10px 0;
  position: relative;
  .waybill{
    .waybill-item{
     display: flex;
     flex-direction: row;
     margin-bottom: 5px;
    .copy{
      color: #555;
    }
    }
    .waybill-item:last-of-type{
      margin-bottom: 0;
    }

  }
  .order-nmb{
    font-weight: 700;
    color: #555;
    width: 200px;
  }
  >span{
    width: 100px;
  }
  p{
    color: #555;
    font-weight: 700;
  }
  .msg_tip{
    flex: 1;
    color: #555;
    font-weight: 700;
  }
  .red{
    width: 45px;
    height: 18px;
    display:inline-block;
    border: 1px solid #FB526EFF;
    color: #FB526EFF;
    text-align: center;
    line-height: 18px;
  }
  .copy{
    width: 43px;
    height: 18px;
    background-color: #EEEEEEFF;
    border-radius: 9px;
    font-size: 12px;
    color: #555;
    line-height: 18px;
    text-align: center;
    font-weight: 400;
  }
}
.order-msg-style{
  align-items:baseline;
}
.full-information{
  width: 103px;
  height: 30px;
  border-radius: 15px;
  border: 1px solid #DCDCDCFF;
  margin: 15px auto 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  >span{
    margin-left: 5px;
  }
}
.fullView-hidden{
  display: none;
}
.manipulate{
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  p{
    width: 65px;
    height: 24px;
    border: 1px solid #BFBFBFFF;
    border-radius: 12px;
    color: #999999FF;
    font-size: 12px;
    line-height: 24px;
    text-align: center;
    margin-right: 15px;
  }
   .identification{
      color:  var(--APP_theme_color);
      border: 1px solid  var(--APP_theme_color);
    }
    .payment{
      color: #fff;
      background-color:  var(--APP_theme_color);
      border: 1px solid  var(--APP_theme_color);
    }
    .pay-refund{
      color: #999999FF;
      border: 1px solid #BFBFBFFF;
    }
}
.invoice-popup{
  margin: 14px 10px;
  .invoice-item{
    display: flex;
    flex-direction: row;
    margin-top: 25px;
    >p{
      width: 100px;
      font-size: 12px;
      color: #777777FF;
    }
    >span{
     font-size: 14px;
     color: #333333FF;
    }
  }
}
.ellipsis{
  width: 100%;
  height: 100%;
  @include center();
  &-icon{
    transform: rotate(90deg);
  }
}
</style>
